import React from "react";
import { Button } from "primereact/button";
import Translate from "Components/Translate";
import { CREATE_FORFAIT } from "Constant";
import OpenModalBtn from "Components/ModalApp/OpenModalBtn";

const CreateForfaitBtn = () => {
  return (
    <OpenModalBtn type="createForfait">
      <Button
        icon="pi pi-plus-circle"
        label={<Translate>{CREATE_FORFAIT}</Translate>}
        severity="info"
        raised
      />
    </OpenModalBtn>
  );
};

export default CreateForfaitBtn;